import React from 'react';
import _get from 'lodash/get';

export default function Content({ data }) {
  const name = _get(data, 'name', 'the');

  return (
    <>
      <p>
        You are about to delete <strong>{name}</strong> return window exception.
      </p>
      <p className="text-muted mb-0">Are you sure you wish to delete?</p>
    </>
  );
}
